import { AxiosResponse } from 'axios';
import { singleton } from 'tsyringe';
import { BaseApiService } from '@shared/_legacy/services/BaseApiService.ts';

@singleton()
export class AkassaMemberApiService extends BaseApiService {
    constructor() {
        super();
    }

    public createFederalCaseAsync = (modelRequest: any, options?: IBaseServiceOptions): Promise<AxiosResponse<any>> => {
        const request: IBaseServiceRequest = {
            url: `api/v1/akassamember/update-payment`,
            model: modelRequest,
            options: options,
        };
        return this.doPost(request);
    };
}
